export default function isTouchDevice() {
  return (
    'ontouchstart' in document.documentElement || // works on most browsers
    'onmsgesesturechange' in window
  ); // works on ie10
}
